// extracted by mini-css-extract-plugin
export default {"phrases-overlay":"PhrasesOverlay_phrases-overlay__T1f-A","phrase":"PhrasesOverlay_phrase__E+LTz","selected":"PhrasesOverlay_selected__u1Idg"};